export default __webpack_public_path__ + "static/media/Bills.5eab08c0.png";